import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'
import Moment from 'moment'
import RaisedButton from 'material-ui/RaisedButton'

import FlatButton from 'material-ui/FlatButton'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import SelectField from 'material-ui/SelectField'
import TextField from 'material-ui/TextField'
import Divider from 'material-ui/Divider'
import Colors from 'material-ui/styles/colors'
import AutoComplete from 'material-ui/AutoComplete';
import MenuItem from 'material-ui/MenuItem';

import newProjectActions from 'actions/newProjectActions'
import dataActions from 'actions/dataActions'
import Error from 'components/Error'
import LeftNavMenu from 'components/LeftNavMenu'
import actionBarActions from 'actions/actionbar'

import {  propertiesExtended } from 'selectors/newProject'
import {  templates, managers } from 'selectors/entities'
import { sort } from 'utils/stuff'

let select = (state) => ({
	...state
  ,	taskTemplates: templates(state)
  , managers: managers(state)
  , properties: propertiesExtended(state)
})

var today = new Date()

export class Project extends Component {
  render(){
		// try {
			let { projectTypeID, propertyID, ownerID } = this.props.newProject
			let { taskTemplates, managers, properties } = this.props
			return(
				<div>
					<header
						style={{
							width: "100%"
						  , height: "109px"
						  , top: "0"
						  , zIndex: "5555"
						  , backgroundColor: "#00ACC1"
						  , position: "fixed"
						  , lineHeight: "60px"
						  , paddingTop: "0"
						  , borderBottom: "1px solid #e1e3e2"
						  , paddingTop: "26px"
						}}
						className="action-bar form-holder"
					>
						<div id="close-project-specs"
							style={{
								lineHeight: "60px"
							}}
						>
							<svg
								width="17px"
								height="17px"
								viewBox="0 0 17 17"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								xmlnsXlink="http://www.w3.org/1999/xlink"
								style={{
									verticalAlign: "middle"
								  , marginLeft: "12px"
								  , cursor: "pointer"
								}}
								onClick={()=>{
									this.props.goBack()
								}}
							>
							    <title>Group</title>
							    <defs></defs>
							    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
							        <g id="Group" transform="translate(1.000000, 1.000000)" stroke="#FFF" strokeWidth="2">
							            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line"></path>
							            <path d="M0.5,0.5 L14.5356684,14.5356684" id="Line" transform="translate(7.500000, 7.500000) scale(-1, 1) translate(-7.500000, -7.500000) "></path>
							        </g>
							    </g>
							</svg>
							<span
								style={{
									fontSize: "24px"
								  , marginTop: "0px"
								  , marginLeft: "10px"
								  , verticalAlign: 'middle'
								  , display: "inline-block"
								  , width: "calc(100% - 29px - 50px)"
								  , textAlign: "center"
								}}
							>
								NEW PROJECT
							</span>
						</div>
				</header>
			      <div style={{padding: "0 54px", marginTop: "125px"}}>
			        <div>
						<SelectField
						  floatingLabelText={(projectTypeID)?"Project template":"Choose project template"}
		                  value={(projectTypeID)? projectTypeID : ""}
		                  onChange={
							  (evt, id, value) => this.props.NEW_PROJECT_CHANGED({projectTypeID: value})
						  }
		                  fullWidth={true}
		                  style={{verticalAlign: 'middle'}}
		                >
							{R.values(sort(taskTemplates, "name")).map((tmpl, indx) => (
									<MenuItem
										key={`${tmpl._id}-manager-${Math.random()}`}
										primaryText={tmpl.title}
										value={tmpl._id}
									/>
								)
							)}
		                </SelectField>
			            <AutoComplete
						  style={{marginTop: "24px", marginBottom: "24px"}}
						  floatingLabelText={(propertyID)?"Property":"Choose property by address, tenant name or phone"}
			              filter={AutoComplete.caseInsensitiveFilter}
			              openOnFocus={true}
			              key={'property-chooser'}
						  searchText={(propertyID)? (propertyID == "All")? "All" :properties[propertyID].alias : ''}
			              onNewRequest={(obj) => this.props.NEW_PROJECT_CHANGED({propertyID: obj.value.props.value})}
			              fullWidth={true}
						  disabled={!R.keys(properties).length}
			              className={`auto-complete-field ${(!R.keys(properties).length)? 'wait-cursor' : ''}`}
			              menuStyle={{maxHeight: '300px', overflowY: 'scroll'}}
			              dataSource={[
							  ...[{
								   text: "All",
								   value: (
									 <MenuItem
									   key={`-6555+65+56+5-property`}
									   primaryText="All"
									   value={"All"}
									 />
								   )
								}]
								,...(R.keys(properties).length)?
									R.values(sort(R.filter(property=> property.status && property.status != 'Retired' , properties), "alias")).map((property, indx) => ({
											text:
												property.alias
												+ ' '
												+ property.address
												+ ' '
												+ ((!!this.props.data[property.leaseID]
													&& this.props.data[property.leaseID].tenantsIDs
													&& this.props.data[property.leaseID].tenantsIDs[0]
													&& this.props.data[this.props.data[property.leaseID].tenantsIDs[0]]
													&& this.props.data[this.props.data[property.leaseID].tenantsIDs[0]].phoneNumber
												)?
													`${this.props.data[this.props.data[property.leaseID].tenantsIDs[0]].phoneNumber.replace(/\D/g, '')} ${this.props.data[this.props.data[property.leaseID].tenantsIDs[0]].firstName} ${this.props.data[this.props.data[property.leaseID].tenantsIDs[0]].lastName}`
													: ' ')
												+ ' ',
											value: (
												<MenuItem
													key={`${property._id}-property-${Math.random()}`}
													primaryText={property.alias}
													value={property._id}
												/>
											)
										}
									))
			                      : ["Pending..."]
						]}
			            />

						<SelectField
						  floatingLabelText={(ownerID)?"Manager":"Choose Project Manager"}
		                  value={(ownerID)? ownerID : ""}
		                  onChange={
							  (evt, id, value) => this.props.NEW_PROJECT_CHANGED({ownerID: value})
						  }
		                  fullWidth={true}
		                  style={{verticalAlign: 'middle'}}
		                >
							{R.values(R.filter((mgr) => !mgr.inactive,sort(managers, "name"))).map((manager, indx) => (
									<MenuItem
										key={`${manager._id}-manager-${Math.random()}`}
										primaryText={manager.name}
										value={manager._id}
									/>
								)
							)}
		                </SelectField>
			        </div>
					<div
						style={{width: "100%"
							, marginLeft: "0px"
							, marginTop: "32px"
							}}
					>
						<RaisedButton
							labelStyle={{
							  lineHeight: "40px"
							}}
							backgroundColor="#3cd2ae"
							labelColor="#FFF"
							label="NEXT"
							fullWidth={true}
							style={{
								height: "40px"
							  , borderRadius: "4px"
							}}
							onClick = { () =>{
								if(!projectTypeID.length || !propertyID.length || !ownerID.length) return
								let projectID = new Date().valueOf().toString()
								let todosWithIds = taskTemplates[projectTypeID].todos.map((todo, indx) => ({
									...todo,
									_id: `${projectID}-${indx}`
								}))
								let tasks = todosWithIds.map((todo) => {
									return todo._id
								})
								todosWithIds.forEach(todo => {
									this.props.DOC_UPDATE({
				  						_id: todo._id
				  						, taskContent: todo.name
				  						, projectID: projectID
				  						, propertyID: propertyID
				  						, done : false
				  						, status: "Open"
										, urgent: false
				  						, note: ""
				  						, schedule: {
				  							  curStart: today
				  							, curDue: new Date(Moment(today).add(((todo.duration)?todo.duration:1), 'days'))
				  							, curDuration: (todo.duration)?todo.duration : 1
				  							, curStrictStart: (todo.strictStart)? todo.strictStart : false
				  							, curStrictDue: (todo.strictDue)? todo.strictDue : false
				  						  }
				  						, managerID : ownerID
				  						, dependencies : (todo.dependencies)? R.filter(todo => todo, R.map((dep) => ((todosWithIds[dep])?todosWithIds[dep]._id: undefined), todo.dependencies)): []
				  						, comments: []
										, type: 'task'
										, taskType: (todo.taskType)? todo.taskType : 'Admin'
									})
								})
								this.props.DOC_UPDATE({
										_id: projectID
									  , title: ((taskTemplates[projectTypeID].title == "Misc")?"":taskTemplates[projectTypeID].title + ", ") + ((propertyID == "All" && !properties[propertyID])? "All" :properties[propertyID]["alias"])
									  , propertyID : propertyID
									  , managerID : ownerID
									  , status : 'Open'
									  , tasks
									  , tenant: (propertyID != "All" && properties[propertyID].tenant)?properties[propertyID].tenant : ''
									  , date : new Date().getTime()
									  , isForAll: ((propertyID == "All" && !properties[propertyID])? true : false)
									  , type: 'project'
								})
								this.props.NEW_PROJECT_CHANGED({projectTypeID : '', propertyID : '', ownerID : ''})
								this.props.history.replace({
									pathname: `/manager/projects/${projectID}`,
									state: { new: true }
								})
							}}
							disabled={!(projectTypeID.length && propertyID.length && ownerID.length)}
						/>
					</div>
			      </div>
			  </div>
			)
		// }catch(err){
		// 	console.error(err)
		// 	return(<Error />)
		// }
	}
}
export default connect(select, R.mergeAll([newProjectActions, dataActions, actionBarActions]))(Project)



// WEBPACK FOOTER //
// ./src/routes/manager/NewProjectForm/index.js